import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CouponManagementSettings = lazy(() => import('../components/CouponManagementSettings'));
const OfferOtpConfig = lazy(() => import('../components/OfferOtpConfig'));
const OfferPrintUnlock = lazy(
  () => import('../../OfferPrintUnlock/components/OfferPrintUnlock')
);

const OfferOtpConfigRoute: RouteObject = {
  path: '/settings/modules/offer-otp',
  element: <CouponManagementSettings />,
  children: [
    {
      index: true,
      element: <OfferOtpConfig />,
    },
    {
      path: 'print-unlock',
      element: <OfferPrintUnlock />,
    },
  ],
};

export default OfferOtpConfigRoute;
